import { init as sentryInit, Replay } from '@sentry/react';
import { CaptureConsole } from '@sentry/integrations';
import { environment } from './environment';

sentryInit({
  dsn: 'https://4a249c88d31a46a783a8b99b19479fec@o930679.ingest.sentry.io/4504824665079808',
  integrations: [
    new Replay({ maskAllText: true, blockAllMedia: true }),
    new CaptureConsole({ levels: ['error'] }),
  ],
  tracesSampleRate: 1.0,
  release: 'local',
  replaysOnErrorSampleRate: 1.0,
  environment: environment.envName,
});
